// #======================================#
// #     _____       _ _       _  _       #
// #    |  __ \     (_) |     | || |      #
// #    | |__) |__ _ _| |___  | || |_     #
// #    |  _  // _` | | / __| |__   _|    #
// #    | | \ \ (_| | | \__ \    | |      #
// #    |_|  \_\__,_|_|_|___/    |_|      #
// #                                      #
// #======================================#

/*global cw_open_register_modal*/
function cw_csrf_protection(xhr) {
  var token = jQuery('meta[name="csrf-token"]').attr('content');
  if (token) {
    xhr.setRequestHeader('X-CSRF-Token', token);
  }
}

function cw_redirect_to_confirm_conditions() {
  if (!window.location.href.toString().match(/\/user\/confirm_conditions/)) {
    var href = '/user/confirm_conditions';
    if (!window.location.href.toString().match(/\?redirect_after=/)) {
      href += '?redirect_after=' + encodeURI(window.location);
    }
    window.location.href=href;
  }
}

/****

  function to show a confirm dialog. the callback must be a function which will
  be called (most of the time) when the dialog is completed.
  If a user cancels dialog by clicking outside of the window it will not be
  called.
  callback arguments is an object : { confirmed: boolean }
  Allows custom text in the buttons of the dialog. This is a tweaked backport of
  v3 `cw_show_confirm_dialog` function.

*/

function cw_show_confirm_custom_btns(title,message,callback,btn_true,btn_false) {
  if(!!btn_true && !!btn_false) {
    $('#cw_modal_confirmdialog_true').text(TRANSLATIONS[btn_true] || "Yes");
    $('#cw_modal_confirmdialog_false').text(TRANSLATIONS[btn_false] || "No");
  }
  cw_show_confirm_dialog(title,message,callback);
}

var cw_packlink_pro_confirmation_eventhandler = null;
function cw_show_packlink_pro_confirmation_dialog(callback) {
  var $modal = $(".js-packlink-pro");
  // NOTE:
  // we don't want to add attrs in the translations, just the links
  // that's the reason, why we add attrs via JS
  $('.cw-modal-body a').attr('target', '_blank');

  if (!cw_packlink_pro_confirmation_eventhandler) {
    cw_packlink_pro_confirmation_eventhandler = { finished: false, callback: callback };

    $modal.on('click', '.option', function(e) {
      e.preventDefault();
      $modal.modal("hide");

      if (!cw_packlink_pro_confirmation_eventhandler.finished) {
        var $option = $(this)
        cw_packlink_pro_confirmation_eventhandler.callback({ confirmed: $option.data('value') });
      }

      cw_packlink_pro_confirmation_eventhandler = { finished: true, callback: null };
    });
  }
  else {
    cw_packlink_pro_confirmation_eventhandler.finished = false;
    cw_packlink_pro_confirmation_eventhandler.callback = callback;
  }

  $modal.addClass('modal').removeClass('mfp-hide');
  $modal.modal();
}

/****

  function to show a confirm dialog. the callback must be a function which will be called (most of the time) when the dialog is completed.
  If a user cancels dialog by clicking outside of the window it will not be called.
  callback arguments is an object : { confirmed: boolean }

*/
var cw_confirmdialog_eventhandler = null;
function cw_show_confirm_dialog(title,message,callback) {

  if(document.apnToolbarUsed || $('body').hasClass("cw_mobile")) {
    // strip html tags.
    message = message.replace(/<[^>]*>/g, " ").replace(/\n/," ").replace(/\s+/g, " ");

    if(confirm(message)) {
      callback({ confirmed: true });

    } else {
      callback({ confirmed: false });
    }
  } else {
    if (!cw_confirmdialog_eventhandler) {
      cw_confirmdialog_eventhandler = { finished: false, callback: callback };
      $("#cw_modal_confirmdialog").on('click',"#cw_modal_confirmdialog_true",function (e) {
        e.preventDefault();
        $("#cw_modal_confirmdialog").modal("hide");
        if (!cw_confirmdialog_eventhandler.finished) {
          cw_confirmdialog_eventhandler.callback({ confirmed: true });
        }
        cw_confirmdialog_eventhandler = { finished: true, callback: null };
      });
      $("#cw_modal_confirmdialog").on('click',"#cw_modal_confirmdialog_false",function (e) {
        e.preventDefault();
        $("#cw_modal_confirmdialog").modal("hide");
        if (!cw_confirmdialog_eventhandler.finished) {
          cw_confirmdialog_eventhandler.callback({ confirmed: false });
        }
        cw_confirmdialog_eventhandler = { finished: true, callback: null };
      });
    }
    else {
      cw_confirmdialog_eventhandler.finished = false;
      cw_confirmdialog_eventhandler.callback = callback;
    }

    var modal = $("#cw_modal_confirmdialog");
    if (modal.hasClass('modal')) { // V2
      $(".modal_header h3",modal).html(title);
      $(".modal_body",modal).html(message);
    } else { // V3
      modal.addClass('modal').removeClass('mfp-hide');
      $(".cw-modal-header h1",modal).html(title);
      $(".cw-modal-body",modal).html(message);
    }

    modal.modal();
  }
}

// =======

function cw_update_undeliverable_email_messages(){
  jQuery.ajax({
    type: 'GET',
    contentType: "text/html; charset=utf-8",
    url: '/user/undeliverable_email_messages',
    cache: false,
    success: function(data) {
      $('#cw_user_undeliverable_email_messages').append(data);
    }
  });
}

function cw_set_dont_show_undeliverable_mail_message_cookie(){
  jQuery.ajax({
    type: 'post',
    contentType: "application/json; charset=utf-8",
    url: '/user/ignore_undeliverable_email_message',
    cache: false
  });
  $.cookie("dont_show_undeliverable_mail_message", true, { expires : 30});
  $('#cw_user_undeliverable_email_messages').remove();
}

function cw_delete_undeliverable_emails() {
  jQuery.ajax({
    type: 'post',
    contentType: "application/json; charset=utf-8",
    url: '/user/remove_from_undeliverable_email_lists',
    cache: false,
    success: function(data) {
      if(data){
        $.cookie("dont_show_undeliverable_mail_message", true, { expires : 30});
        $('#cw_user_undeliverable_email_messages').remove();
      }
    }
  });
}

function is_on_homepage(){
  return $('body').hasClass("frontpage");
}

function getParameterByName(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  results = regex.exec(location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

var ResendEmailVerification = (function (){
  var self = {
    init: function () {
      this.$wrapper = $('.js-resend-email-wrapper');
      this.$container = $('.js-resend-email-container');
      this.successMessage = I18n.translate('successfully_resent_email_confirmation');
      this.hideClass = 'cw-hide';
      this.disabledClass = 'disabled';
      this.successClass = 'success';
      this.warningClass = 'warning';
      this.userId = $.cookie('user_id');
      this.changeUrl = this.$container.data('edit-url');

      if (this.$wrapper.length && this.userId) {
        this.resendUrl = this.$container.data('resend-url').replace(":user_id", this.userId);

        this.$wrapper.removeClass(this.hideClass);
        this.initializeElements();
        this.assignEvents();
        this.render();
      }
    },

    // Due to aggressive caching we need to generate all user specific data
    initializeElements: function () {
      this.$changeButton = $('<a/>', {
        'class': 'cw-alert-actions__link',
        text: I18n.translate('change_email'),
        href: this.changeUrl
      });

      this.$resendButton = $('<a/>', {
        'class': 'btn btn-orange',
        text: I18n.translate('resend_confirmation_email'),
        href: this.resendUrl
      });

      this.$actionContainer = $('<div/>', {
        'class': 'x-col-6-12 cw-alert-actions'
      });

      this.$secondaryMessage = $('<div/>', {
        'class': 'x-col-6-12',
        text: I18n.translate('please_confirm_the_email', {
          email: cw_store.get('user_email')
        })
      });

      this.$subContent = $('<div/>', {
        'class': 'x-grid'
      });

      this.$header = $('.js-resend-email-header', this.$container);
    },

    assignEvents: function () {
      var _this = this;

      this.$resendButton.on('click', function (event) {
        event.preventDefault();

        var $btn = $(this);
        var targetUrl = $btn.attr('href');

        $btn.prop('disabled', true).addClass(_this.disabledClass);

        $.ajax(targetUrl, {
          method: 'POST',
          success: _this.successHandler.bind(_this),
          error: _this.errorHandler.bind(_this)
        });

        dataLayer.push({
          'event': 'topbar_click',
          'eventCategory': 'userregistration',
          'eventLabel': 'resend_email'
        });
      });

      this.$changeButton.on('click', function (event) {
        event.preventDefault();

        dataLayer.push({
          'event': 'topbar_click',
          'eventCategory': 'userregistration',
          'eventLabel': 'change_email'
        });

        window.location = $(this).attr('href');
      });
    },

    render: function () {
      this.$actionContainer.append([this.$changeButton, this.$resendButton]);
      this.$subContent.append([this.$secondaryMessage, this.$actionContainer]);
      this.$container.append(this.$subContent);

      // make sure dataLayer is already declared
      window.dataLayer = window.dataLayer || [];

      dataLayer.push({
        'event': 'topbar_show',
        'eventCategory': 'userregistration',
        'eventLabel': 'email'
      });
    },

    successHandler: function () {
      this.$header.text(this.successMessage);
      this.$subContent.remove();
      this.$container
        .removeClass(this.warningClass)
        .addClass(this.successClass);
    },

    errorHandler: function () {
      this.$resendButton
        .prop('disabled', false)
        .removeClass(this.disabledClass);
    }
  };

  return {
    init: self.init.bind(self)
  }
})();

function cw_check_if_user_confirmed() {
  var user_id = $.cookie('user_id');

  $.ajaxPrefilter(function(options, originalOptions, xhr) { cw_csrf_protection(xhr); });
  jQuery.support.cors = true;
  jQuery.ajax({
    type: 'GET',
    contentType: "application/json; charset=utf-8",
    url: '/accounts/api/v1/users/' + user_id,
    xhrFields: {withCredentials: true},
    cache: false,
    success: function (data) {

      // if user is not confirmed show notification
      if (!data.user.email.confirmed) {
        ResendEmailVerification.init();
      }
    }
  });
}

function cw_update_my_catawiki(){
  var data = {};
  if (is_on_homepage()){
    data['page_type'] = 'homepage';

    var ab_param = getParameterByName("ab_personalised_themed_auctions_on_homepage");
    if (ab_param){
      data['ab_personalised_themed_auctions_on_homepage'] = ab_param;
    }
    if($('body').hasClass('cw_logged_in')){
      data['show_user_dashboard'] = 'true';
    }
  }

  $.ajaxPrefilter(function(options, originalOptions, xhr) { cw_csrf_protection(xhr); });
  jQuery.support.cors = true;
  jQuery.ajax({
    type: 'GET',
    contentType: "application/json; charset=utf-8",
    url: '/catalog/user/my_catawiki_menu_data',
    xhrFields: {withCredentials: true},
    cache: false,
    data: data,
    success: function(data) {
      window.AB_USER_ID = data.my_user_id;
      if (cw_store.enabled){
        cw_store.set('user_email', data.user_email);
        cw_store.set('user_created_at', data.user_created_at);
        cw_store.set('user_name', data.user_best_name);
        cw_store.set('fbFirstName', data.fb_first_name);
        cw_store.set('fbLastName',  data.fb_last_name);
        cw_store.set('fbEmail',     data.fb_email);
        cw_store.set('fbCity',      data.fb_city);
        cw_store.set('fbPhone',     data.fb_phone);
      }

     if (data.user_is_seller) {
       typeof(window.App) !== 'undefined' &&
       typeof(window.App.NotificationService) !== 'undefined' &&
       typeof(window.App.NotificationService.RequestPermission) == 'function' &&
       window.App.NotificationService.RequestPermission();

     }

      /*
       * Since the data response from the parent ajax call is cached
       * we need to make a separate call to the accounts api to make sure
       * we get up to date user-data.
       */
      if (data.hasOwnProperty('user_confirmed')) {
        cw_check_if_user_confirmed();
      }

      var cw_user_navigation = $('#cw_user_navigation, #cw_user_navigation_footer, #cw_navigation_mobile');
      cw_user_navigation.find('.cw_allowed_to_bid').toggle(data.auction_bidder);
      cw_user_navigation.find('.cw_not_allowed_to_bid').toggle(!data.auction_bidder);
      cw_user_navigation.find('.cw_not_allowed_to_consign').toggle(!data.auction_shop);
      cw_user_navigation.find('.cw_allowed_to_consign').toggle(data.auction_shop);
      cw_user_navigation.find('#cw_my_purchases, .cw_my_purchases').toggle(data.my_purchases);
      cw_user_navigation.find('#cw_my_shop, .cw_my_shop').toggle(data.shop_enabled==1);
      cw_user_navigation.find('#cw_my_sold_lots').toggle(data.sold_lots==1);
      cw_user_navigation.find('#cw_my_messages, .cw_my_messages').toggle(data.messages);
      cw_user_navigation.find('#cw_my_auction_lots, .cw_my_auction_lots').toggle(data.auction_lots);
      cw_user_navigation.find('#cw_my_collection').toggle(data.has_collection);
      cw_user_navigation.find('#cw_my_wishlists').toggle(data.has_wish_list);
      cw_user_navigation.find('#cw_new_message_count, .cw_new_message_count').html(data.unread_messages > 0 ? '('+data.unread_messages+')' : '');
      if (data.conditions_accepted===false) {
        cw_redirect_to_confirm_conditions();
      }
      if($('body').hasClass("cw_auction_pages")) {
        if(data.sticky_header_on_auction_pages_type) {
          if(data.sticky_header_on_auction_pages_type == "user_complete_profile") {
            $("body").addClass("complete_profile");
            $('#user_best_first_name').append(data.user_best_name);
            $('#cw_my_catawiki .cw-updates_alert').updatesAlert(1);
          }
        }
      }
      if (is_on_homepage()) {
        cw_show_lists_auctions_actual();
        cw_show_lists_auctions_themed();

        if (data.show_undeliverable_email_message && ($.cookie("dont_show_undeliverable_mail_message") != "true")) {
          cw_update_undeliverable_email_messages();
        }

        //Dashboard on homepage
        if (data.user_name) {
          $('.cw-dashboard--username').append(' ' + data.user_name + ',');
        }
        if (data.number_favorited_lots > 0) {
          $('.cw-dashboard--favorites').text(data.number_favorited_lots);
          if (data.number_favorited_lots == 1) {
            $('.cw-dashboard--favorites--singular').removeClass('hide').removeProp('hidden');
            $('.cw-dashboard--favorites--plural').addClass('hide').prop('hidden', true);
          }
        }
        if (data.auction_lots_bid_on_this_week > 0) {
          $('.cw-dashboard--bids').text(data.auction_lots_bid_on_this_week);
          if (data.auction_lots_bid_on_this_week == 1) {
            $('.cw-dashboard--bids--singular').removeClass('hide').removeProp('hidden');
            $('.cw-dashboard--bids--plural').addClass('hide').prop('hidden', true);
          }
        }
      }

      if(typeof(AB) != "undefined" && AB !== null){
        if(data.outstanding_auction_payments && data.outstanding_auction_payments > 0) {
          //Unpaid purchases
          if (AB.test('auctions_react_outer') == 'A') {
            $('#cw_my_catawiki .cw-updates_alert').updatesAlert(data.outstanding_auction_payments);
            var sub_msg_html = ['<strong>', I18n.translate('unpaid_auction_purchases'), '<span class="cw-updates_alert cw-updates_alert--inline cw-updates_alert--has_updates">', data.outstanding_auction_payments, '</span></strong>'].join('');
            $('#cw_my_purchases').append(sub_msg_html);
            var payments_link = $('#cw_my_purchases').attr('href');
            if (payments_link.indexOf('?') > -1) {
              $('#cw_my_purchases').attr('href', payments_link + '&outstanding=true');
            } else {
              $('#cw_my_purchases').attr('href', payments_link + '?outstanding=true');
            }
          }
        }
        //AB test: show 'My followed auctions' in featured navigation
        if ($('.cw-featured_nav__item--main').hasClass('ab-featured_nav_A') &&
            $(window).width() > 995 &&
            data.show_my_followed_auctions &&
            AB.test('all_auctions_menu_outer') == 'A') {

          var coin_flip = AB.test('following_auctions_in_featured_navigation');
          if(coin_flip == 'B'){
            $('.cw-featured_nav__item--main.ab-featured_nav_A').addClass('cw-hide_on_desktop');
            $('.cw-featured_nav__item--main.ab-featured_nav_B').removeClass('cw-hide_on_desktop');
          }
        }
      }

      // set currency
      if (data.bidding_currency) {
        $('body').attr('class', $('body').get(0).className.replace(/\bcw-currency-\S+/g, ''));
        $('body').addClass('cw-currency-'+data.bidding_currency.toLowerCase());
        $('body').data('bidding_currency', data.bidding_currency );
      }
      else {
        $('body').data('bidding_currency', 'EUR' );
      }

      if( data.converted_to_pound ){
        cwBalloonPopups('currency_balloon', data.converted_to_pound);
      }

      if(data.csphone){
        $('body').addClass('cw-has-phonenumber');
        $('#cw-phonenumber span.number, .cw_main_customer_support span.number').text(data.csphone);
        cw_store.set_session('cs_phonenumber', data.csphone);
      }

      if(data.csphone_times){
        $('.cw_phonenumber_times').html(data.csphone_times.cs_opening_hours);
        $('.cw_phonenumber_header').text(data.csphone_times.cs_phone_header);
        $('.cw_phonenumber_intro').html(data.csphone_times.cs_intro);
        country_select = get_cs_phonesupport_select('cs_other','cs_other',data.csphone_all,  data.csphone_times.cs_select_country,  data.csphone_times.call_free);
        $('.cw_phonenumber_other').html(data.csphone_times.cs_other_country);
        $('.cw_phonenumber_other_select').html(country_select);
        cw_store.set_session('cs_more', JSON.stringify( data.cs_more ));
        $('#cs_other').on('change', function(){
          var $option = $(this).children('option').eq(this.selectedIndex).attr('selected', 'selected');
          var $res = $option[0].value.split("|");
          var $cs_more = data.cs_more;
          $('.cw_phonenumber_other_details').html( $res[1] + " (" + $option[0].text + ")" +  $cs_more[$res[0]]);
        });
        cw_store.set_session('cs_phone_times', data.csphone_times.cs_opening_hours);
        cw_store.set_session('cs_phone_header', data.csphone_times.cs_phone_header);
        cw_store.set_session('cs_other_country', data.csphone_times.cs_other_country);
        cw_store.set_session('cs_select_country', country_select);
        cw_store.set_session('cs_intro', data.csphone_times.cs_intro);
      }

      cwCookieBar.update_user_options(data.cookies_disabled);

      $('.cw-featured_nav__items').removeClass('cw-hide');

      if(typeof(AB) != "undefined" && AB !== null){
        //Marketing Ads experiment
        var liquidityVariant = AB.test('liquidity_user_test', { 'user_id': data.my_user_id }) === 'B';
        dataLayer.push({'liquidityUserTest': liquidityVariant});
      }
    }
  });
}

function cw_update_cs_phone(){
  if(cw_store.get_session('cs_phonenumber') && cw_store.get_session('cs_more') && cw_store.get_session('cs_intro') && cw_store.get_session('cs_phone_times') && cw_store.get_session('cs_other_country') && cw_store.get_session('cs_select_country')){
    $('body').addClass('cw-has-phonenumber');
    $('#cw-phonenumber span.number, .cw_main_customer_support span.number').text(cw_store.get_session('cs_phonenumber'));
    $('.cw_phonenumber_times').html(cw_store.get_session('cs_phone_times'));
    $('.cw_phonenumber_header').text(cw_store.get_session('cs_phone_header'));
    $('.cw_phonenumber_intro').html(cw_store.get_session('cs_intro'));
    $('.cw_phonenumber_other').html(cw_store.get_session('cs_other_country'));
    $('.cw_phonenumber_other_select').html(cw_store.get_session('cs_select_country'));
    $('#cs_other').on('change', function(){
      var $option = $(this).children('option').eq(this.selectedIndex).attr('selected', 'selected');
      var $res = $option[0].value.split("|");
      var cs_more = JSON.parse(cw_store.get_session('cs_more'));
      $('.cw_phonenumber_other_details').text($res[1] + " (" + $option[0].text + ")"  +  $cs_more[$res[0]]);
    });
  }else{
    cw_update_my_catawiki();
  }
}

function get_cs_phonesupport_select(name, id, optionList, intro, call_free) {
  var combo = $("<select></select>").attr("id", id).attr("name", name);
  combo.append("<option value=\"\">" + intro+ "</option>");
  $.each(optionList, function (i, el) {
    combo.append("<option value=\"" +  el.short_code + "|" + call_free + " " + el.customer_support_phone + "\">" + el.name + "</option>");
  });
  return combo.get(0).outerHTML;
}


function cwBalloonPopups(id, fire){
  if(!id || !fire){return false;}
  if($('.cw-balloon-msg').not('.hide').length > 0 || !cw_store.enabled){return false;}
  var balloon = $('#'+id+'.cw-balloon-msg');
  if(balloon.length == 0){return false;}
  if(fire && cw_store.get(id) != 'true'){
    balloon.removeClass('hide');
    setTimeout(function(){
      balloon.addClass('show').find('.close').on('click', function(){
        balloon.removeClass('show');
        setTimeout(function(){
          balloon.addClass('hide');
        }, 400);
        cw_store.set(id, 'true');
      });
    }, 2000);
  }else{
    balloon.addClass('hide');
  }
}

function replace_auctions_with_custom_list(list, offset) {
  offset = offset || 0;
  replace_list_with_custom_list(list, '#cw_lists_auctions_actual .cw-tiles .cw-list-item', offset);
}

function replace_list_with_custom_list(list, element, offset){
  offset = offset || 0;
  for(var i = offset; i < offset+list.length; i++) {
    $(element)[i].outerHTML = list[i-offset];
  }
}

function cw_show_lists_auctions_themed(){
  $('#cw_lists_auctions_themed').removeClass('hide');
  $('#cw_lists_auctions_themed').blockLinks();
  $('#cw_lists_auctions_themed .cw-list-item .cw-content h2').sameHeight();
  $('#cw_lists_auctions_themed .cw-list-item .cw-content .info').sameHeight();
}

function cw_show_lists_auctions_actual(){
  $('#cw_lists_auctions_actual').removeClass('invisible');
  $('#cw_lists_auctions_actual').blockLinks();
  $('#cw_lists_auctions_actual .cw-tiles').each(function(){
    $(this).find('.cw-list-item .cw-content h2').sameHeight();
    $(this).find('.cw-list-item .cw-content .info').sameHeight();
  });
}

function ga_set_custom_dimension(dimension, value){
  if(value && dimension){
    //ga('set', ('dimension'+dimension), value);
    //ga('send', 'event', 'AB testing', ('dimension'+dimension), value, {nonInteraction:true});
    dataLayer.push({
      'event': 'ab_cd_push',
      'eventCategory': 'AB testing',
      'eventAction': ('dimension'+dimension),
      'eventLabel': value,
      'cdIndex': dimension,
      'cdValue': value
    });
  }
}


(function($) {

  $.fn.extend({

    // make elements stick to top on scroll
    makeSticky: function(sticky_top){
      sticky_top = sticky_top || 0;
      var $els = $(this);
      var stickies = [];
      $els.each(function(i){
        stickies[i] = {};
        stickies[i].$el = $(this);
        if (stickies[i].$el.attr('data-pushup')) {
          stickies[i].$pushup = $(stickies[i].$el.attr('data-pushup'));
        } else {
          stickies[i].$pushup = false;
        }
        stickies[i].pos_left = Math.round(stickies[i].$el.offset().left);
        stickies[i].pos_top = Math.round(stickies[i].$el.offset().top);
        stickies[i].sticky = 'off';
        // touch devices can't do sticky and show keyboard at the same time...
        // so turn off stickyness on focus
        if (Modernizr.touch) {
          var timer;
          stickies[i].$el
            .on('focusin.makeSticky', 'input,textarea,select', function(e) {
              var $_this = $(this);
              $(window).off('scroll.makeSticky');
              stickyOff(stickies[i]);
              stickies[i].$el.css({
                'transform': 'none'
              });
              timer = setTimeout(function(){
                if ($_this.offset().top - $(window).scrollTop() > 72) {
                  $(window).scrollTop($_this.offset().top - 72);
                }
                stickies[i].$el.off('focusin.makeSticky');
              }, 500);
            });
            // .on('focusout.makeSticky', 'input,textarea,select', function(e) {
            //   timer = setTimeout(function(){
            //     $(window).on('scroll.makeSticky', doOnScroll);
            //     $(window).trigger('scroll');
            //   }, 1000);
            // });
        }
      });
      var stickyOn = function(sticky) {
        sticky.$el.addClass('cw-sticky-on');
        sticky.sticky = 'on';
      };
      var stickyOff = function(sticky) {
        sticky.$el.removeClass('cw-sticky-on');
        sticky.sticky = 'off';
        pushupOff(sticky);
      };
      var pushupOn = function(sticky, scrollTop, sticky_top) {
        $('html').addClass('cw-sticky-pushup');
        if (Modernizr.csstransforms3d) {
          sticky.$el.css({
            'transform': 'translate3d(0,' + (sticky.$pushup.offset().top - scrollTop - sticky.$el.outerHeight() - sticky_top) + 'px,0)'
          });
        } else {
          sticky.$el.css({
            'margin-top': (sticky.$pushup.offset().top - scrollTop - sticky.$el.outerHeight() - sticky_top) + 'px'
          });
        }
      };
      var pushupOff = function(sticky) {
        $('html').removeClass('cw-sticky-pushup');
        if (Modernizr.csstransforms3d) {
          sticky.$el.css({
            'transform': 'none'
          });
        } else {
          sticky.$el.css({
            'margin-top': 0
          });
        }
      };
      var doOnScroll = function() {
        var scrollTop = $(window).scrollTop();
        $els.each(function(i){
          if (stickies[i].sticky=='off' && (scrollTop+sticky_top) > stickies[i].pos_top) {
            stickyOn(stickies[i]);
          } else if (stickies[i].sticky=='on' && (scrollTop+sticky_top) <= stickies[i].pos_top) {
            stickyOff(stickies[i]);
          }
          if (stickies[i].sticky=='on' && stickies[i].$pushup.length) {
            if ((scrollTop+sticky_top) > stickies[i].$pushup.offset().top - stickies[i].$el.outerHeight()) {
              pushupOn(stickies[i], scrollTop, sticky_top);
            } else {
              pushupOff(stickies[i]);
            }
          }
        });
      };
      $(window).on('scroll.makeSticky', throttle(doOnScroll, 1000/120));
      $(window).trigger('scroll');
    },

    sameHeight: function(anim){
      var $self = $(this);
      var animation = anim || false; // animation default false
      var heights = [];
      $self.each(function(){
        heights[heights.length] = $(this).outerHeight();
      });
      var maxH = Math.max.apply(Math, heights);
      $self.addClass('same-height').each(function(){
        var pad = parseInt($(this).css('padding-top'),10) + parseInt($(this).css('padding-bottom'),10);
        if (animation) {
          $(this).animate({
            minHeight: maxH - pad + 1
          }, 500);
        } else {
          $(this).css({
            minHeight: maxH - pad + 1
          });
        }
      });
    },

    newWindow: function(features){
      features = features || null;
      $(this).each(function() {
        $(this).on('click.newWindow', function(evt) {
          evt.preventDefault();
          evt.stopPropagation();
          window.open(this.href, 'CatawikiPopup', features);
        });
      });
    },

    cwTooltip: function(options){
      var $tt;
      var timer;
      var popover_timer;
      var popover = (options && options['popover']);
      var speed = 250;
      var ttShow = function($el, txt) {
        clearTimeout(timer);
        $el.attr('title', '');
        var inner_class = popover ? 'c-alert' : 'cw-tooltip-inner';
        $tt = $('<div/>').addClass('cw-tooltip').css({
          opacity: 0,
          visibility: 'hidden'
        }).append($('<div/>').addClass(inner_class).text(txt));
        if(popover) {
          $tt.addClass('cw-popover');
        } else if (txt.length > 80) {
          $tt.addClass('cw-tooltip-xl');
        } else if (txt.length > 40) {
          $tt.addClass('cw-tooltip-large');
        }
        $('body > .cw-tooltip').remove();
        $('body').append($tt);
        setTimeout(function(){
          var x = $el.offset().left + ($el.width() / 2);
          var y = $el.offset().top + $el.height();
          if (x > $('body').width() - $tt.width()/2) {
            if(popover){
              $tt.addClass('cw-popover--right-aligned');
            }else{
              x = $('body').width() - $tt.width()/2;
            }
          } else if (x < $tt.width()/2) {
            x = $tt.width()/2;
          }
          $tt.css({
            left: x,
            top: y
          });
          timer = setTimeout(function(){
            $tt.css({
              opacity: 1,
              visibility: 'visible'
            });
          }, speed);
        }, 0);
      };
      var ttHide = function($el, txt) {
        clearTimeout(timer);
        if ($tt) {
          $tt.css({
            opacity: 0
          });
          timer = setTimeout(function(){
            $tt.remove();
            $el.attr('title', txt);
          }, speed);
        }
      };
      var popoverHide = function($el, txt, delay) {
        clearTimeout(popover_timer);
        var timeout = delay || 1000;
        popover_timer = setTimeout(function(){
          ttHide($el, txt);
        }, timeout);
      };
      $(this).each(function(){
        var tag_name = $(this).get(0).tagName;
        var txt = $(this).attr('title');
        if(popover){
          if(txt && $(this).is(':visible')){
            ttShow($(this), txt);
            if($('html').hasClass('mod-touch')){
              $('body').on('touchstart.cwPopover', function(evt){
                popoverHide($(this), txt);
                $('body').off('touchstart.cwPopover');
              });
            }else{
              $(this).on('mouseleave', function(){
                popoverHide($(this), txt);
              });
            }
            popoverHide($(this), txt, 20000);
          }
        } else if (txt && !$('html').hasClass('mod-touch')) {
          var event_in, event_out, $element_in, $element_out;
          if (tag_name == "INPUT") {
            event_in = 'focus';
            event_out = 'blur';
          } else {
            event_in = 'mouseenter';
            event_out = 'mouseleave';
          }
          $(this).on(event_in, function(){
            ttShow($(this), txt);
          });
          $(this).on(event_out, function(){
            ttHide($(this), txt);
          });
        } else if (txt) {
          $(this).on('touchstart.cwTooltip', function(evt){
            evt.stopPropagation();
            var $_this = $(this);
            ttShow($_this, txt);
            $('body').on('touchstart.cwTooltip', function(evt){
              ttHide($_this, txt);
              $('body').off('touchstart.cwTooltip');
            });
          });
        }
      });
    },

    blockLinks: function() {
      $(this).find('[data-link]').each(function(){
        var $self = $(this);
        var href = $self.find($self.attr('data-link')).attr('href');
        $self
          .hover(function(){
            $self.addClass('hover');
          }, function(){
            $self.removeClass('hover');
          })
          .on('click', function(){
            document.location.href = href;
          })
          .find('.cw-stop_prop').on('click.stop_prop', function(event){
            event.stopPropagation();
          });
      });
    },

    updatesAlert: function(inc) {
      var $el = $(this);
      var counter = parseInt($el.text()) || 0;
      counter += inc;
      if (counter > 0) {
        $el.addClass('cw-updates_alert--has_updates').text(counter);
      } else {
        $el.removeClass('cw-updates_alert--has_updates').text('0');
      }
    },

    stickToTop: function() {
      // not working yet!
      var $els = $(this);
      $els.each(function(){
        var $el = $(this);
        var $clone = $el.clone().addClass('cw-stick_to_top__sticky');
        $el.before($clone);
      });
      var $stickies = $('.cw-stick_to_top__sticky');
      var doOnScroll = function() {
        var scrollTop = $(window).scrollTop();
        $els.each(function(){
          var $el = $(this);
          var $sticky = $el.prev('.cw-stick_to_top__sticky');
          if (scrollTop < $el.offset().top - 67) {
            $el.removeClass('cw-stick_to_top--active');
            $sticky.removeClass('cw-stick_to_top__sticky--active');
            return false;
          } else {
            $els.not($el).removeClass('cw-stick_to_top--active');
            $stickies.not($sticky).removeClass('cw-stick_to_top__sticky--active');
            $el.addClass('cw-stick_to_top--active');
            $sticky.addClass('cw-stick_to_top__sticky--active');
          }
        });
      };
      $(window).on('scroll.stickToTop', throttle(doOnScroll, 1000/60));
      $(window).trigger('scroll');
    }

  });

  $.extend({
    cwQuerystringParameters: {
      get: function() {
        var querystring_parts = window.location.search.replace('?', '').split('&');
        var params = {};
        for (var i=0; i<querystring_parts.length; i++) {
          var key_val = querystring_parts[i].split('=');
          if (key_val.length > 1) {
            params[key_val[0]] = key_val[1];
          }
        }
        return params;
      },
      set: function(params, prefix) {
        if (history && history.pushState) {
          prefix = (prefix && document.location.pathname.indexOf(prefix) != document.location.pathname.length - prefix.length) ? prefix : ''; // if prefix is not yet in pathname
          var querystring = [];
          $.each(params, function(param_key, param_val){
            if (param_val) {
              querystring.push(param_key + "=" + param_val);
            }
          });
          querystring = querystring.join('&');
          history.pushState(null, null, document.location.pathname+prefix+'?'+querystring);
        }
      }
    }
  });

  var smoothAnchors = function(offset, beforeScroll, afterScroll) {
    var my_offset = offset || 0;
    var my_beforeScroll = beforeScroll || function() {};
    var my_afterScroll = afterScroll || function() {};
    var speed = 400;
    var scrollIt = function(hash, $target) {
      $target = $target || $(document.getElementById(hash.slice(1)));
      $target = $target.length && $target || $('[id="' + hash.slice(1) +'"]');
      $target = $target.length && $target || $('a[name="' + hash.slice(1) +'"]');
      if ($target.length) {
        var targetOffset = $target.offset().top;
        my_beforeScroll();
        $('html,body').animate({scrollTop: targetOffset - my_offset}, speed, function(){
          if (history && history.pushState) {
            history.pushState(null, null, hash);
          }
          $target.focus();
          my_afterScroll();
        });
      }
    };
    $('a[href*=#]').not('.cw-tabs-tab_link, .cw-toggle_link').not('[class*="js-"]').on('click.smoothAnchors', function(event) {
      if (this.hash) {
        try {
          var $target = $(this.hash);
        } catch(e) {
          var $target = null;
        }
        if ($target) {
          $target = $target.length && $target || $('a[name="' + this.hash.slice(1) +'"]');
          $target = $target.length && $target || $('[id="' + this.hash.slice(1) +'"]');
          if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname && $target.length > 0) {
            event.preventDefault();
            scrollIt(this.hash, $target);
          }
        }
      }
    });
    var current_hash = document.location.hash;
    if (current_hash) {
      $('body').imagesLoaded(function(){
        setTimeout(function(){
          scrollIt(current_hash);
        }, 100);
      });
    }
  };



  var cwToggleLinks = function() {
    // use .cw-toggle_link to show/hide $(:data-target)
    // use .open on .cw-toggle_link to set default state "open"
    var toggleText = function($toggle_link) {
      var newtext = $toggle_link.attr('data-hidetext');
      if (newtext) {
        var hidetext = $toggle_link.text();
        $toggle_link.text(newtext);
        $toggle_link.attr('data-hidetext', hidetext);
      }
    };
    var toggleIt = function($toggle_link, $target) {
      if ($toggle_link.hasClass('open')) {
        $toggle_link.removeClass('open');
        $target.addClass('hide').removeClass('cw-toggle_link-open').addClass('cw-toggle_link-closed');
        HashBang.set('toggle', '');
      } else {
        $toggle_link.addClass('open');
        $target.removeClass('hide cw-toggle_link-closed').addClass('cw-toggle_link-open');
        HashBang.set('toggle', $toggle_link.attr('data-target').replace('#', ''));
      }
      toggleText($toggle_link);
    }
    var getTarget = function($toggle_link) {
      return $($toggle_link.attr('data-target'));
    }
    var $toggle_links = $('.cw-toggle_link');
    $toggle_links.each(function(){
      var $toggle_link = $(this);
      var $target = getTarget($toggle_link).addClass('cw-toggle_link-target');
      if (!$toggle_link.hasClass('open')) {
        $target.addClass('hide').removeClass('cw-toggle_link-open').addClass('cw-toggle_link-closed');
      } else {
        toggleText($toggle_link);
      }
      $toggle_link.on('click.cw_toggle', function(event){
        event.preventDefault();
        toggleIt($toggle_link, $target);
      });
    });
    var toggle_from_hash = HashBang.get('toggle');
    if (toggle_from_hash) {
      var $current_toggle = $toggle_links.filter('[data-target="#'+toggle_from_hash+'"]').eq(0);
      toggleIt($current_toggle, getTarget($current_toggle));
    }
  };



  var cwCollapsibles = function() {
    var trigger_selector = 'h1, h2';
    $('.cw-collapsible').each(function(){
      var $item = $(this);
      $item.find(trigger_selector).eq(0)
        .addClass('cw-collapsible-trigger')
        .on('click.cwCollapsibles', function(event){
          event.preventDefault();
          $item.toggleClass('cw-collapsed');
        })
    });
  };



  var toggleGrid = function() {
    $(window).keypress(function(event) {
      if (event.which == 169) { // alt-cmd-G
        $('body').toggleClass('grid');
      }
    });
  };



  var Mason = function(container, items) {
    this.container = container;
    this.$container = $(container);
    this.items = items;
    this.filters = {};
    if (this.$container.attr('data-infinite-scroll') == 'true') {
      this.infinite_scroll = true;
    } else {
      this.infinite_scroll = false;
    }
  };

  Mason.prototype.init = function() {
    var self = this;
    var layout = self.$container.attr('data-layout-mode') || 'masonry';
    //self.$container.imagesLoaded(function(){
      self.$container.isotope({
        layoutMode: layout,
        itemSelector: self.items
      });
      $('a[data-filter-target="'+self.container+'"]').each(function(){
        var $this = $(this);
        if ($this.attr('data-filter') == '*') {
          $this.addClass('active');
        }
        var item_count = self.$container.find(self.items).filter($this.attr('data-filter')).length;
        $this.on('click', function(event){
          event.preventDefault();
          self.$container.parent().find('p.cw-no-results').remove();
          var $buttonGroup = $this.closest('.cw-button-group');
          $buttonGroup.find('.active').removeClass('active');
          $(this).addClass('active');
          var noResultsText = $buttonGroup.attr('data-no-results-text');
          if (item_count < 1 && noResultsText) {
            noResultsText = noResultsText.replace('%{category_name}', $(this).text().toLowerCase());
            self.$container.before(
              $('<p/>').addClass('cw-no-results cw-centered').text(noResultsText)
            );
          }
          var filterGroup = $buttonGroup.attr('data-filter-group');
          self.filters[filterGroup] = $this.attr('data-filter');
          self.applyFilters();
          if (history && history.pushState) {
            history.pushState(null, null, this.href);
          }
        });
      });
      $('select[data-filter-target="'+self.container+'"]').each(function(){
        var $buttonGroup = $(this).closest('.cw-button-group');
        var filterGroup = $buttonGroup.attr('data-filter-group');
        $(this).on('change', function(){
          var $this = $(this);
          var $option = $this.children('option').eq(this.selectedIndex).attr('selected', 'selected');
          var item_count = self.$container.find(self.items).filter($option.attr('data-filter')).length;
          $('.cw-msnry-count').text(item_count);
          cwPluralize($('.cw-msnry-count-pluralize'), item_count);
          self.$container.parent().find('p.cw-no-results').remove();
          var noResultsText = $buttonGroup.attr('data-no-results-text');
          if (item_count < 1 && noResultsText) {
            noResultsText = noResultsText.replace('%{category_name}', $(this).text().toLowerCase());
            self.$container.before(
              $('<p/>').addClass('cw-no-results cw-centered').text(noResultsText)
            );
          }
          self.filters[filterGroup] = $option.attr('data-filter');
          HashBang.set('filter-'+filterGroup, $this.val());
          self.applyFilters();
        });
        var current_filter = HashBang.get('filter-'+filterGroup);
        if (current_filter) {
          for (var i=0; i<$(this).get(0).options.length; i++) {
            if ($(this).get(0).options[i].value == current_filter) {
              $(this).get(0).selectedIndex = i;
              $(this).trigger('change');
              break;
            }
          }
        }
      });
      if (self.infinite_scroll) {
        self.infiniteScroller();
      }
    //});
  };

  Mason.prototype.applyFilters = function() {
    var filterValue = '';
    for (var prop in this.filters) {
      filterValue += this.filters[prop];
    }
    if (filterValue == '*' || filterValue == '') {
      this.$container.removeClass('cw-msnry-filtered');
    } else {
      this.$container.addClass('cw-msnry-filtered');
    }
    this.$container.isotope({ filter: filterValue });
    window.setTimeout(function(){
      $(window).trigger('scroll'); // trigger lazy images
    }, 750);
  };

  Mason.prototype.infiniteScroller = function() {
    $('section.cw-footer').hide();
    var self = this;
    var last = $('.cw-pager').find('a').not('.cw-pager-next').not('.cw-pager-hidden-next').last().text();
    $('.cw-pager').css('visibility', 'hidden');
    var $binder = $(window);
    var img_data = "data:image/gif;base64,R0lGODlhEAALAPQAAP///wAAANra2tDQ0Orq6gYGBgAAAC4uLoKCgmBgYLq6uiIiIkpKSoqKimRkZL6+viYmJgQEBE5OTubm5tjY2PT09Dg4ONzc3PLy8ra2tqCgoMrKyu7u7gAAAAAAAAAAACH+GkNyZWF0ZWQgd2l0aCBhamF4bG9hZC5pbmZvACH5BAALAAAAIf8LTkVUU0NBUEUyLjADAQAAACwAAAAAEAALAAAFLSAgjmRpnqSgCuLKAq5AEIM4zD";
    img_data += "Vw03ve27ifDgfkEYe04kDIDC5zrtYKRa2WQgAh+QQACwABACwAAAAAEAALAAAFJGBhGAVgnqhpHIeRvsDawqns0qeN5+y967tYLyicBYE7EYkYAgAh+QQACwACACwAAAAAEAALAAAFNiAgjothLOOIJAkiGgxjpGKiKMkbz7SN6zIawJcDwIK9W/HISxGBzdHTuBNOmcJVCyoUlk7CEAAh+QQACwADACwAAAAAEAALAAAFNSAgjqQIRRFUAo3jNGIkSdHqPI8Tz3V55zuaDacDyIQ+YrBH+";
    img_data += "hWPzJFzOQQaeavWi7oqnVIhACH5BAALAAQALAAAAAAQAAsAAAUyICCOZGme1rJY5kRRk7hI0mJSVUXJtF3iOl7tltsBZsNfUegjAY3I5sgFY55KqdX1GgIAIfkEAAsABQAsAAAAABAACwAABTcgII5kaZ4kcV2EqLJipmnZhWGXaOOitm2aXQ4g7P2Ct2ER4AMul00kj5g0Al8tADY2y6C+4FIIACH5BAALAAYALAAAAAAQAAsAAAUvICCOZGme5ERRk6iy7qpyHCVStA3gNa/7txxwlwv2";
    img_data += "isSacYUc+l4tADQGQ1mvpBAAIfkEAAsABwAsAAAAABAACwAABS8gII5kaZ7kRFGTqLLuqnIcJVK0DeA1r/u3HHCXC/aKxJpxhRz6Xi0ANAZDWa+kEAA7AAAAAAAAAAAA";
    self.$container.infinitescroll(
      {
        binder: $binder,
        navSelector  : '.cw-pager',
        nextSelector : '.cw-pager a.cw-pager-next',
        itemSelector : '.cw-msnry ' + self.items,
        loading: {
          finishedMsg: "",
          img: img_data,
          msgText: "",
          speed: 0
        },
        bufferPx: $(window).height() * 2,
        maxPage: last,
        debug: false
      },
      function(newElements, opts) {
        var $newElems = jQuery(newElements).hide();
        $newElems.imagesLoaded(function(){
          $newElems.fadeIn();
          self.$container.isotope('appended', $newElems);
          self.$container.blockLinks();
          if (opts.state.currPage >= last) {
            $('section.cw-footer').show();
          }
          if (window.AuctionFavorites !== undefined && window.AuctionPage !== undefined) {
            AuctionFavorites.activate_favorites_async(AuctionPage);
          }
        });
      }
    );
  };



  var mediaQuotes = function() {
    var $quotes = $('#media-quotes ul.cw-columns > li');
    var makeActive = function($el) {
      $quotes.removeClass('cw-active');
      $el.addClass('cw-active');
    };
    $quotes.each(function(){
      $(this).on('mouseover', function(){
        makeActive($(this));
      }).on('touchstart', function(){
        makeActive($(this));
      });
    });
  };



  var pageFillHeight = function() {
    $('body').imagesLoaded(function(){
      var window_height = $(window).height();
      if ($('body').outerHeight() < window_height) {
        $('#cw-main').css('min-height', window_height - $('.cw-footer').height() - parseInt($('body').css('padding-top'),10));
      }
    });
  };



  var cwTabs = function() {
    var hideAll = function($tab_links) {
      $tab_links.each(function(){
        $(this).parent('li').removeClass('active');
        var h = $(this).attr('href');
        $(h).hide();
      });
    };
    $('.cw-tabs-active').each(function(){
      var $tabs = $(this);
      var $tab_links = $tabs.find('a');
      // make tab_links open their tab and close all others
      $tab_links.each(function(){
        var $_this = $(this);
        var h = $_this.attr('href');
        $(h).addClass('tab-pane');
        var $other_links = $('a[href="'+h+'"]').not($_this);
        $other_links.addClass('cw-tabs-tab_link').off('click.smoothAnchors').on('click.cwTabs', function(event){
          event.preventDefault();
          $_this.trigger('click');
          var targetOffset = $_this.offset().top;
          $('html,body').animate({scrollTop: targetOffset - 75}, 500, function(){
            $(h).focus();
          });
        });
        $_this.addClass('cw-tabs-tab_link').off('click.smoothAnchors').on('click.cwTabs', function(event){
          event.preventDefault();
          hideAll($tab_links);
          $(this).parent('li').addClass('active');
          $(h).show();
          if (set_hash) {
            HashBang.set('tab', h.replace('#', ''));
          }
          set_hash = ($tabs.data('set_hash') == true);
          $(window).trigger('scroll');
        });
      });
      var tab_id = '';
      // check if there's a valid tab selected in url hash
      var current_tab = '#' + HashBang.get('tab');
      var $current_tab = $tab_links.filter('[href="'+current_tab+'"]');
      var real_hash = document.location.hash;
      var $real_hash = $(document.getElementById(real_hash.slice(1)));
      // maybe the url hash is a tab-pane?
      if ($real_hash.length && $current_tab.length < 1) {
        if ($real_hash.hasClass('.tab-pane')) {
          $current_tab = $tab_links.filter('[href="'+real_hash+'"]');
        }
      }
      // maybe there's a hash within a tab-pane selected?
      if ($real_hash.length && $current_tab.length < 1) {
        tab_id = $real_hash.closest('.tab-pane').attr('id');
        $current_tab = $tab_links.filter('[href="#'+tab_id+'"]');
      }
      // if still no valid tab selected, select the default tab (.active)
      if ($current_tab.length < 1) {
        $current_tab = $tabs.find('li.active a');
      }
      var set_hash = false;
      // click the selected tab (if so), else click the first tab
      if ($current_tab.length) {
        $current_tab.trigger('click');
      } else {
        $tab_links.eq(0).trigger('click');
      }
    });
  };



  // conditional comment for <IE9, but more browsers don't support svg... :(
  var changeSVGtoPNG = function() {
    if ($('html').hasClass('mod-no-inlinesvg')) {
      $('img').each(function(){
        var src = $(this).attr('src');
        if (src.indexOf('.svg') > -1) {
          $(this).attr('src', src.replace('.svg', '.png'));
        }
      });
    }
  };



  function loadSocialMediaAsync() {
  }



  //set login class on body
  var setLoginClass = function() {
  }

  // activate popups & modals
  var activatePopups = function($container) {
    $container = $container || $('html');
    if(!$("html").hasClass("lt-ie8")) {
      $container.find("a.register_link").click(function(event) {
        $(this).blur();
        event.preventDefault();
        $('html').addClass('mfp-open');
        var url = $(this).attr('data-magnific-popup-link');
        cw_open_register_modal($, url);
      });
    }
    var makePopup = function($el,options) {
      options = options || {} ;
      var scrollTo = $el.data('cw-ajax-modal-scroll-to');
      var is_wide = $el.data('cw-ajax-modal-wide') || false;
      var is_medium = $el.data('cw-ajax-modal-medium') || false;
      var typeStr = options.inline ? 'inline' : 'ajax';
      var load_only = $el.data('cw-ajax-modal-load-only');
      var load_only_child = $el.data('cw-ajax-modal-load-only-child');
      var support_cors = $el.data('support_cors') || false;
      var dialog = {
        type: typeStr,
        mainClass: (is_wide) ? 'cw-popup-wide' : ((is_medium) ? 'cw-popup-medium' : 'cw-popup-normal'),
        callbacks: {
          parseAjax: function(mfpResponse) {
            mfpResponse.data = $(mfpResponse.data);
            if (load_only) {
              var $content = $('<div class="cw_white_modal_block" />');
              var $title = $(mfpResponse.data).find(load_only);
              var $text;
              $title.each(function(){
                $text = $(this).next();
                if(load_only_child){
                  var $child = $text.find(load_only_child);
                  if($child.length){
                    $text = $('<p />').text($child.text());
                  }
                }
                $content.append(this).append($text);
              });
              mfpResponse.data = $content;
            }
            $(mfpResponse.data).find('#managed_content table').attr('border', '0').addClass('table-striped');
            $(mfpResponse.data).find('a.replace_popup').each(function(i) {
              $(this).each(function() {
                makePopup($(this));
              });
            });
            createPopupLinks($(mfpResponse.data));
            $(mfpResponse.data).find('a.cw-popup_link').newWindow('width=750,height=525,status=1,location=1');
          },
          ajaxContentAdded: function() {
            moveCloseButton();
            cw_check_disable_loading_buttons($);
            $('input, textarea').placeholder();
            if (scrollTo) {
              var el = document.getElementById(scrollTo);
              if (el) {
                el.scrollIntoView();
              }
            }
          }
        }
      };
      if (support_cors) {
        dialog.ajax = {
          settings: {
            beforeSend: function(request) {
              request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            },
            xhrFields: {
              withCredentials: true
            }
          }
        }
      }
      if (options.inline) {
        if ($el.data('cw-inline-modal-target')) {
          var $content = $($el.data('cw-inline-modal-target')).hide();
        } else {
          var $content = $('<div class="cw_white_modal_block" />');
          if (options.title) {
            $content.append($('<h1>' + options.title + '</h1>'));
          }
          if (options.body) {
            $content.append($('<p>' + options.body + '</p>'));
          }
        }
        createPopupLinks($content);
        dialog.items = {
          type: 'inline',
          src: $content
        }
        dialog.callbacks.open = function() {
          $('html').addClass('mfp-open');
          $content.show();
          $(window).trigger('scroll');
        }
        dialog.callbacks.close = function() {
          $('html').removeClass('mfp-open');
          $content.hide();
          HashBang.set('auctioneer', '');
        }
      }
      return $el.magnificPopup(dialog);
    };
    var moveCloseButton = function(){ // button needs to be moved out of the content!
      $('.mfp-container button.mfp-close').each(function(){
        $(this).appendTo($(this).closest('.mfp-container'));
        $container.find('.cw-has_tooltip').cwTooltip();
      });
    };
    var createPopupLinks = function($el){
      $el.find('a.cw-ajax_popup').magnificPopup({ // load original link in popup through ajax
        type: 'ajax',
        width: 640,
        gallery: {
          enabled: true,
          tPrev: TRANSLATIONS.gallery_previous_left_key,
          tNext: TRANSLATIONS.gallery_next_right_key,
          tCounter: '<span class="mfp-counter">'+TRANSLATIONS.gallery_x_of_total+'</span>'
        },
        callbacks: {
          ajaxContentAdded: function() {
            moveCloseButton();
          }
        }
      });
      $el.find("*[data-cw-inline-modal=true]").each(function() {
        makePopup($(this), {
          inline: true,
          title: $(this).data('cw-title'),
          body: $(this).data('cw-text')
        });
      });
      $el.find("*[data-cw-ajax-modal=true]").each(function() {
        makePopup($(this));
      });
    };
    createPopupLinks($container);
    $.magnificPopup.defaults.callbacks = {
      open: function() {
        $('html').addClass('mfp-open');
      },
      close: function() {
        $('html').removeClass('mfp-open');
      },
      change: function() {
        setTimeout(function(){
          moveCloseButton();
          $('body > .cw-tooltip').remove();
        }, 0);
      },
      ajaxContentAdded: function() {
      }
    };
    $.fn.extend({
      modal: function(param) {
        if (param == 'hide') {
          $.magnificPopup.close();
        } else {
          $(this).find('.cw-modal-close').on('click', function(){
            $.magnificPopup.close();
          });
          $.magnificPopup.open({
            modal: true,
            type: 'inline',
            items: {
              src: $(this)
            }
          });
        }
      }
    });
    if (TRANSLATIONS) {
      $.magnificPopup.defaults.tLoading = TRANSLATIONS.loading + "…";
    }
  };
  $.fn.extend({
    activatePopups: function() { activatePopups($(this)); }
  });


  var initGalleries = function($container) {
    $container = $container || $(document);
    $container.find("*[data-cw-gallery=true]").each(function() {
      var delegate = $(this).data("cw-delegate");
      if(!delegate) {
        delegate = "a";
      }
      $(this).magnificPopup({
        delegate: delegate,
        type: 'image',
        gallery: {
          enabled: true,
          tPrev: TRANSLATIONS.gallery_previous_left_key,
          tNext: TRANSLATIONS.gallery_next_right_key,
          tCounter: '<span class="mfp-counter">'+TRANSLATIONS.gallery_x_of_total+'</span>'
        }
      });
    });
  };

  var showLoginModal = function () {
    if((new RegExp("[\\?&]show_login_modal=true")).test(location.href)) {
      var qs = "";
      var lot_id = $('.row.cw_lot_content .lot.detail #lot_id').val();
      var auction_id = $('.cw_auction_content input#auction_id').val();

      if(typeof lot_id != 'undefined') {
        qs = "?lot_id="+encodeURIComponent(lot_id);
      } else if(typeof auction_id != 'undefined') {
        qs = "?auction_id="+encodeURIComponent(auction_id);
      }
      $.magnificPopup.open({
        items: {
          src: '/catalog/register_user/show_login_modal' + qs
        },
        type: 'ajax',
        callbacks: {
          ajaxContentAdded: function() {
            $('.mfp-ajax-holder button.mfp-close').each(function(){
              $(this).appendTo($(this).closest('.mfp-ajax-holder'));
            });
          }
        }
      }, 0);
    }
  };



  // Inline Hints (implement as cw-assets plugin later!)
  window.inlineHints = {
    hints: {},
    hideEvent: 'mousedown.inline_hints, touchstart.inline_hints',
    lastFocus: null,
    init: function(){
      this.attachHints($('a.js-inline-hint-trigger'));
      this.hints = $('.c-inline-hint');
      this.hints.each(function(){
        var $hint = $(this);
        $hint.find('.c-inline-hint__inner').on(window.inlineHints.hideEvent, function(evt){
          evt.stopPropagation();
        });
        $hint.find('.c-inline-hint__close').on('click', function(evt){
          window.inlineHints.closeHint($hint);
        });
      });
    },
    attachHints: function($triggers) {
      $triggers.on('click.inline_hints', function(evt){
        evt.preventDefault();
        window.inlineHints.openHint($($(this).attr('href')));
      });
    },
    openHint: function($hint) {
      if ($hint.hasClass('open')) {
        this.closeHint($hint);
      } else {
        this.closeAllHints();
        this.lastFocus = document.activeElement;
        $hint.addClass('open').removeAttr('hidden').attr('tabindex', '0').trigger('focus');
        $('body').on(this.hideEvent, function(){
          window.inlineHints.closeAllHints();
        });
        $(document).on('keydown.inline_hints', function(evt) {
          if (evt.keyCode == 27 ) { // Escape key
            evt.preventDefault();
            window.inlineHints.closeAllHints();
          }
        });
      }
    },
    closeHint: function($hint) {
      $hint.addClass('closing').removeAttr('tabindex');
      $('body').off(this.hideEvent);
      $(document).off('keydown.inline_hints');
      $(this.lastFocus).trigger('focus');
      setTimeout(function(){
        $hint.removeClass('closing open').attr('hidden', 'true');
      }, 500);
    },
    closeAllHints: function() {
      var $open_hints = this.hints.filter('.open');
      if ($open_hints.length > 0) {
        this.closeHint($open_hints);
      }
    }
  };



  // App signup
  var appSignup = function() {
    if ($.cookie("app_signup_success")) {
      $('#cw_app_signup_linkbanner, #cw_app_signup_banner, .app_signup_linkbanner_small, .app_signup_link').remove();
    }
  };



  var cwNiceSelects = function() {
    $('div.cw-custom_select').remove();
    $('select.cw-nice_select').each(function(){
      var $_this = $(this);
      var state = false;
      var $custom_select = $('<div/>')
        .addClass('cw-custom_select')
        .text(cwGetSelectedOptionText($_this))
        .append(
          $('<span/>').addClass('cw-custom_select-button')
        );
      $_this
        .css({
          'position': 'absolute',
          'z-index': 1,
          'opacity': 0
        })
        .after($custom_select)
        .on('focus.cwNiceSelects', function(){
          if (!state) {
            state = true;
            $custom_select.addClass('active');
          }
        })
        .on('blur.cwNiceSelects', function(){
          if (state) {
            state = false;
            $custom_select.removeClass('active');
          }
        })
        .on('change.cwNiceSelects', function(){
          $custom_select.text(cwGetSelectedOptionText($_this)).append(
            $('<span/>').addClass('cw-custom_select-button')
          );
        });
    });
  };
  $.extend({
    cwNiceSelects: cwNiceSelects
  });


  var cwLotGallery = function() {
    // dependent on Photoswipe!
    // http://photoswipe.com/
    if (typeof PhotoSwipe !== "undefined") {
      var speed = 250;
      var thumb_size = 50;
      var thumb_margin = 10;
      var nav_size = 34;
      var ambilight = false; // for later... :)
      var pswp;
      var caption = $('.cw-page_title > h1 > .lot_title').text();
      var initLightbox = function($gallery, index) {
        index = index || 0;
        var options = {
          index: index, // start at first slide
          bgOpacity: 0.75,
          closeOnScroll: false,
          history: false,
          maxSpreadZoom: 3,
          shareButtons: [
            { id:'download', label:'Download image', url:'{{raw_image_url}}', download:true }
          ],
          shareEl: false,
          getThumbBoundsFn: function() {
            var thumbnail = $gallery.big_image_link.find('img').get(0);
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          }
        };
        pswp = new PhotoSwipe($('.pswp').get(0), PhotoSwipeUI_Default, $gallery.items, options);
        pswp.listen('afterChange', function() {
          if ($gallery) {
            setIndex($gallery, this.getCurrentIndex());
          }
        });
        pswp.listen('initialZoomIn', function() {
          $('html').addClass('pswp-open');
        });
        pswp.listen('close', function() {
          $('html').removeClass('pswp-open');
        });
        pswp.listen('destroy', function() {
          $gallery.main.focus();
          initLightbox($gallery, this.getCurrentIndex());
        });
        $gallery.big_image_link.on('click.lot_gallery', function(event){
          event.preventDefault();
          pswp.init();
        });
      };
      $('.cw-lot-images').each(function(){
        var $gallery = {};
        $gallery.main = $(this);
        $gallery.thumbs = $gallery.main.find('.cw-lot-images-thumbs').eq(0);
        $gallery.big_image = $gallery.main.find('.cw-image-big').eq(0);
        $gallery.big_image_link = $gallery.big_image.find('a').eq(0);
        $gallery.big_image_img = $gallery.big_image_link.find('img').eq(0);
        if (ambilight) {
          $gallery.big_image_blur = $gallery.big_image.children('.cw-image-big-blur').eq(0);
          $gallery.big_image_blur.css({
            'background-image': 'url(' + $gallery.big_image_img.attr('src') + ')'
          });
        }
        if ($gallery.thumbs.length > 0) {
          $gallery.thumbs.find('.cw-lot-images-thumb a')
            .each(function(i){
              $(this).on('click.lot_images', function(event){
                event.preventDefault();
                initLightbox($gallery, i);
                setIndex($gallery, i, $(this));
              });
            })
            .eq(0).addClass('active');
          var $previous_thumbs = $('<a/>')
            .addClass('cw-lot-images-thumbsnav-previous')
            .html('&#xe0c7;')
            .on('click.lot_images_nav', function(event){
              event.preventDefault();
              $gallery.thumbs.animate({scrollLeft: '-='+($gallery.thumbs.innerWidth()-(nav_size*2-thumb_margin))}, speed*2);
            })
            .hide();
          var $next_thumbs = $('<a/>')
            .addClass('cw-lot-images-thumbsnav-next')
            .html('&#xe0ca;')
            .on('click.lot_images_nav', function(event){
              event.preventDefault();
              $gallery.thumbs.animate({scrollLeft: '+='+($gallery.thumbs.innerWidth()-(nav_size*2-thumb_margin))}, speed*2);
            })
            .hide();
          var $previous_image = $('<a/>')
            .addClass('cw-lot-images-nav cw-lot-images-nav-previous')
            .html('&#xe0bb;')
            .attr('title', TRANSLATIONS.gallery_previous_left_key)
            .on('click.lot_images_nav', function(event){
              event.preventDefault();
              navigatePrevious($gallery.main);
            });
          var $next_image = $('<a/>')
            .addClass('cw-lot-images-nav cw-lot-images-nav-next')
            .html('&#xe0be;')
            .attr('title', TRANSLATIONS.gallery_next_right_key)
            .on('click.lot_images_nav', function(event){
              event.preventDefault();
              navigateNext($gallery.main);
            });
          var timer;
          $gallery.main
            .attr('tabindex', 1)
            .on('focus', function(){ activateKeys($gallery.main); })
            .on('blur', function(){ deactivateKeys($gallery.main); })
            .append(
              $('<div/>').addClass('cw-lot-images-thumbsnav').append($previous_thumbs).append($next_thumbs)
            );
          $gallery.big_image
            .append($previous_image)
            .append($next_image);
          $gallery.main.find('a')
            .attr('tabindex', 1)
            .on('focus', function(){ activateKeys($gallery.main); })
            .on('blur', function(){ deactivateKeys($gallery.main); });
          $gallery.thumbs
            .on('DOMMouseScroll mousewheel', function(event){
              // prevent scroll event bubbling up to the whole document
              var s = $(this).scrollLeft();
              if (s < 1 && event.originalEvent.deltaX < 0) {
                event.preventDefault();
              }
              if (s >= $gallery.thumbs.get(0).scrollWidth - $gallery.thumbs.innerWidth() && event.originalEvent.deltaX > 0) {
                event.preventDefault();
              }
            })
            .on('scroll.lot_images_nav', function(){
              var s = $(this).scrollLeft();
              if (s < 1) {
                $previous_thumbs.fadeOut(speed);
              } else {
                $previous_thumbs.fadeIn(speed);
              }
              if (s >= $gallery.thumbs.get(0).scrollWidth - $gallery.thumbs.innerWidth()) {
                $next_thumbs.fadeOut(speed);
              } else {
                $next_thumbs.fadeIn(speed);
              }
              $(window).trigger('scroll'); // trigger lazy images
            });
          if ($gallery.thumbs.get(0).scrollWidth > $gallery.thumbs.innerWidth()) {
            $next_thumbs.show();
          }
        }
        // lightbox
        $gallery.items = [];
        if ($gallery.thumbs.length > 0) {
          $gallery.thumbs.find('a').each(function(){
            var item_width = $(this).attr('data-original-width');
            var item_height = $(this).attr('data-original-height');
            if (item_width == 'auto' || item_height == 'auto') {
              var $item_image = $(this).find('img').eq(0);
              item_width = $item_image.width() * 14;
              item_height = $item_image.height() * 14;
            }
            $gallery.items[$gallery.items.length] = {
              src: $(this).attr('href'),
              msrc: $(this).attr('href'),
              w: item_width,
              h: item_height,
              title: caption
            };
          });
          initLightbox($gallery);
        } else {
          var item_width = $gallery.big_image_link.attr('data-original-width');
          var item_height = $gallery.big_image_link.attr('data-original-height');
          if (item_width == 'auto' || item_height == 'auto') {
            item_width = $gallery.big_image_img.width() * 2;
            item_height = $gallery.big_image_img.height() * 2;
          }
          $gallery.items[0] = {
            src: $gallery.big_image_link.attr('href'),
            msrc: $gallery.big_image_link.attr('href'),
            w: item_width,
            h: item_height,
            title: caption
          };
          initLightbox($gallery);
        }
      });
      var setIndex = function($gallery, i, $el) {
        $el = $el || $gallery.thumbs.find('.cw-lot-images-thumb a').eq(i);
        $gallery.main.find('.active').removeClass('active');
        $el.addClass('active');
        var url = $el.attr('href');
        $gallery.big_image_link.attr('href', url);
        $gallery.big_image_img.attr('src', url);
        if (ambilight) {
          $gallery.big_image_img.on('load', function(){
            $gallery.big_image_blur.css({
              'background-image': 'url('+url+')'
            });
          });
        }
        // scroll thumbs in to view
        if ($gallery.thumbs.length > 0) {
          var y_pos = $gallery.thumbs.scrollLeft() - $gallery.thumbs.offset().left + $el.offset().left;
          if ($el.offset().left - $gallery.thumbs.offset().left > $gallery.thumbs.innerWidth() - (thumb_size+nav_size)) {
            // too far to the right
            $gallery.thumbs.animate({scrollLeft: y_pos - $gallery.thumbs.innerWidth() + nav_size + thumb_size}, speed/2);
          }
          else if ($el.offset().left - $gallery.thumbs.offset().left < nav_size) {
            // too far to the left
            $gallery.thumbs.animate({scrollLeft: y_pos - nav_size}, speed/2);
          }
        }
      };
      var activateKeys = function($gallery) {
        $gallery.on('keydown.lot_images', function(event) {
          if (event.keyCode == 37 || event.keyCode == 38) { // left or up
            event.preventDefault();
            navigatePrevious($gallery);
          }
          if (event.keyCode == 39 || event.keyCode == 40) { // right or down
            event.preventDefault();
            navigateNext($gallery);
          }
          if (event.keyCode == 13) { // enter
            event.preventDefault();
            openLightbox($gallery);
          }
        });
      };
      var deactivateKeys = function($gallery) {
        $gallery.off('keydown.lot_images');
      };
      var navigatePrevious = function($gallery) {
        var $current_thumb = $gallery.find('a.active').parent();
        if ($current_thumb.hasClass('cw-lot-images-thumb-first')) {
          $gallery.find('.cw-lot-images-thumbs .cw-lot-images-thumb-last a').eq(0).trigger('click');
        } else {
          $current_thumb.prev().find('a').eq(0).trigger('click');
        }
      };
      var navigateNext = function($gallery) {
        var $current_thumb = $gallery.find('a.active').parent();
        if ($current_thumb.hasClass('cw-lot-images-thumb-last')) {
          $gallery.find('.cw-lot-images-thumbs .cw-lot-images-thumb-first a').eq(0).trigger('click');
        } else {
          $current_thumb.next().find('a').eq(0).trigger('click');
        }
      };
      var openLightbox = function($gallery) {
        $gallery.find('.cw-image-big > a.cw-image-big-link').eq(0).trigger('click');
      };
    }
  };


  var cwSlider = function() {
    var speed = 500;
    var fps = 30;
    $('.cw-slider').each(function(){
      var $container = $(this);
      var $slider = $container.find('.cw-tiles');
      var $slide_previous = $('<a/>')
        .addClass('cw-slider__nav__previous inactive')
        .on('click.slider', function(event){
          event.preventDefault();
          $slider.animate({scrollLeft: '-='+($slider.innerWidth() - 40)}, speed);
        })
        .append(
          $('<span/>').html('&#xe0c7;')
        );
      var $slide_next = $('<a/>')
        .addClass('cw-slider__nav__next inactive')
        .on('click.slider', function(event){
          event.preventDefault();
          $slider.animate({scrollLeft: '+='+($slider.innerWidth() - 40)}, speed);
        })
        .append(
          $('<span/>').html('&#xe0ca;')
        );
      $container.append(
        $('<div/>').addClass('cw-slider__nav').append($slide_previous).append($slide_next)
      );
      var doOnScroll = function(){
        var s = $slider.scrollLeft();
        if (s < 1) {
          $slide_previous.addClass('inactive');
        } else {
          $slide_previous.removeClass('inactive');
        }
        if (s >= $slider.get(0).scrollWidth - $slider.innerWidth()) {
          $slide_next.addClass('inactive');
        } else {
          $slide_next.removeClass('inactive');
        }
        $(window).trigger('scroll'); // trigger lazy images
      }
      $slider.on('scroll.slider', throttle(doOnScroll, 1000/fps));
      if ($slider.get(0).scrollWidth > $slider.innerWidth()) {
        $slide_next.removeClass('inactive');
      }
    });
  };



  var cwPreventFocusZoom = function() {
    var viewportmeta = document.querySelector('meta[name="viewport"]');
    var viewport_original = viewportmeta.content;
    var viewport_no_zoom = "width=device-width,initial-scale=1,maximum-scale=1.0";
    var disableZoom = function() {
      var $inputs = $('input, textarea');
      $inputs.each(function(){
        $(this)
          .on('touchstart.cwPreventFocusZoom focus.cwPreventFocusZoom', function(){
            viewportmeta.content = viewport_no_zoom;
          })
          .on('blur.cwPreventFocusZoom', function(){
            viewportmeta.content = viewport_original;
          });
      });
    };
    if (viewportmeta && Modernizr.touch) {
      disableZoom();
    }
  };



  var initLazyload = function() {
    $(".cw-lazy_images_collection").each(function(){
      var $_this = $(this);
      var timer = null;
      $_this.find("img.lazy").lazyload({
        threshold: 200,
        load: function() {
          if ($_this.data('isotope')) {
            if (!timer) {
              timer = setTimeout(function(){ // throttle
                $_this.isotope();
                timer = null;
              }, 1000);
            }
          }
        }
      });
    });
  };



  var cwBacklinks = function() {
    $('a.cw-back_link').on('click.back_link', function(evt){
      if (window.history.length > 1) {
        evt.preventDefault();
        window.history.back();
      }
    });
  };



  var cwAuctioneers = function() {
    var $container = $('#cw_auctioneers_overview');
    var $iso_list = $container.find('.cw-tiles.cw-msnry');
    var $auctioneers = $iso_list.find('.cw-list-item[data-cw-inline-modal="true"]');
    var $filter = $container.find('select');
    $auctioneers.each(function() {
      $(this)
        .addClass('active')
        .hover(function(){
          $(this).addClass('hover');
        }, function(){
          $(this).removeClass('hover');
        })
        .on('touchstart', function(){
          $(this).addClass('hover');
        })
        .on('touchend', function(){
          $(this).removeClass('hover');
        })
        .on('click', function(){
          var auctioneer_id = $(this).attr('data-auctioneer_id');
          HashBang.set('auctioneer', auctioneer_id);
        })
        .find('a')
          .on('click', function(evt){
            evt.stopPropagation();
          });
    });
    $filter.on('change', function(){
      $("img.lazy").updateLazyLoad();
    });
    var current_auctioneer = HashBang.get('auctioneer');
    if (current_auctioneer > 0) {
      $auctioneers.filter('[data-auctioneer_id='+current_auctioneer+']').trigger('click');
      $(window).trigger('scroll'); // trigger lazy images
    }
  };



  var cwColorize = function() {
    // item selector: .cw-colorize
    // set item background-color to the average color of the top part of the 1st image found in item
    if (supportCanvas()) {

      var debug = false;
      var total_time = 0;
      var border_fraction = 0.02; // take top 5% of image

      var getColor = function($item, image){
        if (debug) {
          console.log('--- Colorize image ---');
          if (window.performance.now) {
            var t1 = window.performance.now();
          } else {
            var t1 = new Date().getTime();
          }
        }
        var canvas = document.createElement('canvas');
        var canvasContext = canvas.getContext("2d");
        // resize image (4*20) to make processing faster
        var w = 4;
        var h = 50;
        canvas.width = w;
        canvas.height = h;
        canvasContext.drawImage(image, 0, 0, w, h);
        // try, because image server may nog support CORS,
        // or browser might not handle it correctly (IE10)
        try {
          var image_data = canvasContext.getImageData(0, 0, w, h);
          var image_rgba_data = image_data.data; // array [R,G,B,a,R,G,B,a,R,G,B,a,...]
          var pixels = Math.ceil((image_rgba_data.length * border_fraction) / 4);// how many pixels in the crop
          var rgb = {r:0,g:0,b:0};
          for (var i=0; i<pixels*4; i+=4) {
            rgb.r += image_rgba_data[i];
            rgb.g += image_rgba_data[i+1];
            rgb.b += image_rgba_data[i+2];
          }
          // calculate averages for R/G/B
          rgb.r = Math.round(rgb.r / pixels);
          rgb.g = Math.round(rgb.g / pixels);
          rgb.b = Math.round(rgb.b / pixels);
          $item.css('background-color', 'rgb('+rgb.r+','+rgb.g+','+rgb.b+')');
          if (debug) {
            if (window.performance.now) {
              var t2 = window.performance.now();
            } else {
              var t2 = new Date().getTime();
            }
            var time_taken = t2 - t1;
            total_time += time_taken
            console.log('rgb('+rgb.r+','+rgb.g+','+rgb.b+') | ' + (Math.round(time_taken*1000)/1000) + 'ms / ' + (Math.round(total_time)/1000) + 's | "' + image.alt + '"');
          }
        }
        catch(err) {
          if (debug) {
            console.log('ERROR:');
            console.log($item);
            console.log(image);
            console.log(err);
          }
        }
      };

      if (!$('html').hasClass('lt-ie10')) {
        $('.cw-colorize').each(function(){
          // crossOrigin loading through attribute not reliable on iOS9,
          // so set it through javascript
          var $item = $(this);
          var image = $item.find('img').get(0);
          var src = $(image).attr('src');
          if (image) {
            if (src != '/images/img_place_holder.gif') {
              // not lazy loaded: re-request image with crossOrigin
              image = new Image();
              image.crossOrigin = 'anonymous';
              image.src = src + '?cors=true';
            } else {
              image.crossOrigin = 'anonymous';
            }
            $(image).on('load.cwColorize', function() {
              getColor($item, image);
            });
          }
        });
      }

    }
  };



  var calculateShippingCosts = function() {
    var $shipping_rate = $('.js-shipping_rate_container').first();
    var url = $shipping_rate.data('packlink_url');
    var allowed_carrier_names = $shipping_rate.data('carriers');
    var service_filter = $shipping_rate.data('service_filter'); // all / pickup / dropoff
    var vat_shipping_rate = $shipping_rate.data('vat_shipping_rate');
    var prices = [];
    if (url) {
      $.ajax(url, {
        complete: function(jqXHR, textStatus) {
          if (textStatus == 'success') {
            var carriers = JSON.parse(jqXHR.responseText);
            var cheapest_carrier = false;
            $(carriers).each(function(){
              // check if it's in allowed carriers
              if ($.inArray(this.carrier_name, allowed_carrier_names) !== -1) {
                // check dropoff / pickup
                if ((service_filter == 'pickup' && !this.dropoff) || (service_filter == 'dropoff' && this.dropoff) || (service_filter != 'pickup' && service_filter != 'dropoff')) {
                  // check if it's cheapest
                  if (!cheapest_carrier || parseFloat(this.base_price) < parseFloat(cheapest_carrier.base_price)) {
                    cheapest_carrier = this;
                  }
                }
              }
            });
            if (cheapest_carrier) {
              var base_price = parseFloat(cheapest_carrier.base_price);
              var price = (1 + vat_shipping_rate/100) * base_price;
              var formatted_price = Catawiki.currencyHelper.localize(price, {currency: Catawiki.currencyHelper.biddingCurrency, floatValue: true, skipCurrenciesFilter: true});
              $('.js-shipping_rate_container__value').each(function(){
                $(this).html(formatted_price);
              });
            }
          }
        }
      });
    }
  };



  var areYouSureLinks = function() {
    $('a.cw-are_you_sure').on('mousedown', function(event){
      event.preventDefault();
      if (confirm(TRANSLATIONS.are_you_sure)) {
        jQuery(this).trigger('click');
      } else {
        return false;
      }
    });
  };

  var dynamiclyLoadedAuctions = function(){
    var containerID = '#dynamiclyLoadedAuctions';
    var goAhead = ($(containerID).length > 0 && $(containerID).data('dynamic-auction-path'));
    if(goAhead){
      $.ajax({
        type: 'GET',
        url: $(containerID).data('dynamic-auction-path'),
        data: {'locale': $('body').data('lang')},
        cache: false,
        success: function(data) {
          if(data.length > 10){
            $(containerID).html(data).blockLinks();
            initLazyload();
            new Mason(containerID).init();
            abClickConversions();
            $(window).trigger('scroll');
          }else{
            window.location = window.location.href.replace('?type=recommended', '');
          }
        }
      });
    }
  }

  window.cwInitResponsiveness = function(){
    // extra info (from sidebar) in dropdown
    var $side_menu = $('#cw-mobile-side_menu');
    if ($side_menu.length > 0 && $(window).width() < 747) {
      var $side_menu_switch = $side_menu.find('.more_auctions_dropdown__trigger').eq(0).removeClass('hide');
      var $list = $side_menu.find('ul.cw-list-thumb_list, .more_auctions_dropdown__content').eq(0);
      $side_menu.addClass('more_auctions_dropdown').prependTo($('.cw-auction').eq(0));
      var openExtraMenu = function() {
        $side_menu.addClass('open');
        $('body').on('mousedown.ExtraMenu touchstart.ExtraMenu', function(evt){
          closeExtraMenu();
        });
      };
      var closeExtraMenu = function() {
        $side_menu.removeClass('open');
        $('body').off('mousedown.ExtraMenu touchstart.ExtraMenu');
      };
      $side_menu_switch.on('click', function(evt){
        if ($side_menu.hasClass('open')) {
          closeExtraMenu();
        } else {
          openExtraMenu();
        }
      });
      $side_menu.on('mousedown touchstart', function(evt){
        evt.stopPropagation();
      });
    }
  };

  // Recent search storage
  $("#cw-searchbox form, .cw-hero .cw-searchbox form").on('submit', function(event) {
    if (cw_store.enabled) {
      var max_search_history_length = 5;
      var search_history_key = 'previous_searches';
      var search_query = $(event.target).find('input[type=search]').val();
      // Do nothing if search query is empty
      if (search_query && search_query !== '') {
        var search_history = cw_store.get_json(search_history_key) || [];
        search_history.unshift(search_query);
        // Only store latest 3 unique searches
        cw_store.set_json(search_history_key, $.unique(search_history).reverse().slice(0, max_search_history_length));
      }
    }
  });

  $("#cw-searchbox, .cw-searchbox").on('awesomplete-select', function(event) {
    var origin = $(event.originalEvent.origin);
    if (origin.hasClass('search-history-delete')) {
      var search_history_key = 'previous_searches';
      var search_history = cw_store.get_json(search_history_key) || [];
      var index = $.inArray(origin.data('text'), search_history);
      if (index !== -1) {
        search_history.splice(index, 1);
        cw_store.set_json(search_history_key, search_history);
      }
      origin.parent().remove();
      return false;
    }
    return true;
  });

  // Search autocomplete
  // https://leaverou.github.io/awesomplete/
  var searchAutocomplete = {
    settings: {
      results_limit: 10,
      keystroke_timer: 0
    },
    init: function(){
      // only do AB test when a user focuses the search box!
      if (typeof(Awesomplete) != 'undefined') { // not available in < IE9
        $("#cw-searchbox input[data-autocomplete], .cw-hero .cw-searchbox input").each(function(){
          var $input = $(this);
          $input.on('focus.searchcomplete', function(){
            $input.off('focus.searchcomplete');
            if (['zh_CN', 'zh_TW'].indexOf($('body').data('lang')) == -1) {
              searchAutocomplete.attach($input);
              setTimeout(function(){
                $input.trigger('focus');
              }, 0);
            }
          });
        });
      }
    },
    attach: function($input){
      var minAutocompleteChars = 3;
      var instance = new Awesomplete($input.get(0), {
        minChars: 0,
        maxItems: 10, // this.settings.results_limit,
        list: [],
        sort: function (a, b) { return b.value.score - a.value.score; },
        data: function (item, input) {
          return {
            label: item.label,
            value: item.value
          };
        },
        item: function(item, input) {
          // Stolen from awesomplete's default `item' function
          // See https://github.com/catawiki/cw-catalog/blob/master/public/javascripts/v3/awesomplete/awesomplete.js#L279
          var html = input === '' ? item.label : item.label.replace(RegExp(input.trim().replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&"), "gi"), "<mark>$&</mark>");
          if (item.value.category_name !== undefined) {
            html += '<span class="category-name">' + item.value.category_name + '</span>';
          }
          if (item.value.search_history === true) {
            var tooltip_text = I18n.translate('remove', { 'default': 'Remove' });
            html += '<span class="search-history-delete" data-text="' + item.label + '" title="' + tooltip_text + '">×</span>';
          }
          var css_class = 'cw-autosuggest ';
          css_class += item.value.with_category ? 'with-category ' : 'without-category ';
          css_class += item.value.search_history ? 'search-history ' : '';
          return ($('<li>', {
            'aria-selected': false,
            'class': css_class,
            'html': html
          }))[0];
        },
        replace: function(item) {
          if (item.value.url !== undefined) {
            window.location.href = item.value.url + "?" + $.param({ q: item.label });
            return;
          }
          instance.input.value = instance.suggestions[instance.index].label;
          $(instance.input).closest('form').trigger('submit');
        },
        filter: function (text, input) {
          // don't let Awesomplete filter, API already returns filtered data!
          return true;
        },
      });
      var keystroke_timer, reset_timer;
      var time_before_new_request = 0;
      $input.on('awesomplete-highlight', function(evt){
        instance.input.value = instance.suggestions[instance.index].label;
      }).on(($('html').hasClass('lt-ie10') ? 'focus keyup' : 'focus input'), function(evt) {
        var q = $(this).val();
        if (q.length >= minAutocompleteChars ) {
          clearTimeout(keystroke_timer);
          keystroke_timer = setTimeout(function(){
            // do next request after timer, unless timer has already passed
            time_before_new_request = searchAutocomplete.settings.keystroke_timer;
            clearTimeout(reset_timer);
            reset_timer = setTimeout(function(){
              time_before_new_request = 0;
            }, time_before_new_request);
            $.ajax({
              type: 'GET',
              url: $input.data('autocomplete_url'),
              xhrFields: {
                withCredentials: true
              },
              data: {
                'q': q,
                'size': searchAutocomplete.settings.results_limit
              },
              success: function(data) {
                var result = [];
                var show_results_from = 0;
                if (data.query_terms.length > 0) {
                  var search_term = data.query_terms[0].text;
                  if (data.show_categories === true) {
                    show_results_from = 1;
                    // Duplicate the first result with main categories
                    result = result.concat(data.query_terms[0].categories.map(function(elt, i) {
                      return {
                        label: search_term,
                        value: {
                          score: elt.hits,
                          category_id: elt.category_id,
                          url: elt.url,
                          category_name: elt.category_name,
                          with_category: true,
                          search_history: false
                        }
                      }
                    }));
                  }
                }
                // Get the rest of the results
                result = result.concat($(data.query_terms).slice(show_results_from).map(function(i, e) {
                  return {
                    label: e.text,
                    value: { score: 0, with_category: false, search_history: false }
                  };
                }).toArray());
                instance.list = result;
              }
            });
          }, time_before_new_request);
        } else if (q.length === 0) {
          var search_history = cw_store.get_json('previous_searches') || [];
          if (search_history.length > 0 && AB && AB.test && AB.test('search_history_in_autocomplete') == 'B') {
            var items = $.map(search_history, function(item) {
              if (item && item !== '') {
                return {
                  label: item,
                  value: { score: 0, with_category: false, search_history: true }
                };
              } else {
                return null;
              }
            });
            instance.list = $.grep(items, function(item) {
              return item !== null;
            });
          }
        } else {
          instance.list = [];
        }
      });
    }
  };

  // Notifications
  window.cwNotifications = {
    settings: {
      useAPI: false
    },
    $container: $('<div/>').addClass('c-notifications'),
    $template: $('<a/>').addClass('c-notifications__item'),
    $image: $('<img/>').attr({
      width: 54,
      height: 54,
      alt: ""
    }).addClass('c-notifications__item__image'),
    init: function(){
      $('body').append(this.$container);
    },
    notify: function(content, t, icon, url, id) {
      // text to show, time before disappear (in seconds) (optional), icon url, url to visit on click (optional), identifier (optional)
      id = id || null;
      url = url || null;
      icon = icon || null;
      t = t || 4;
      var success = false;
      if (this.settings.useAPI && ("Notification" in window)) { // Try to use Notifications API
        Notification.requestPermission();
        if (Notification.permission === "granted") {
          success = true;
          var n = new Notification(content, {
            icon: icon,
            tag: 'alert',
            body: '',
          });
          n.onclick = function(){
            document.location.href = url;
            n.close();
          };
        }
      }
      if (!success) { // Not using Notifications API
        var $notification = this.$template.clone().html(content).attr('href', url);
        if (id) {
          if ($('.c-notifications__item[data-notification_id=' + id + ']').length) { // existing notification with this id
            return false;
          }
          else {
            $notification.attr('data-notification_id', id);
          }
        }
        if (icon) {
          $notification.prepend(this.$image.clone().attr('src', icon));
        }
        $notification.append(
          $('<div/>').addClass('c-notifications__item__close').on('click', function(evt){
            evt.stopPropagation();
            evt.preventDefault();
            window.cwNotifications.closeNotification($notification);
          })
        );
        this.$container.append($notification);
        setTimeout(function(){
          $notification.addClass('active');
          var close_timer = setTimeout(function(){
            window.cwNotifications.closeNotification($notification);
          }, t*1000);
          $notification.hover(
            function(){
              clearTimeout(close_timer);
            },
            function(){
              close_timer = setTimeout(function(){
                window.cwNotifications.closeNotification($notification);
              }, t*1000);
            }
          );
        }, 100);
        return $notification;
      }
    },
    closeNotification: function($notification) {
      $notification.removeClass('active');
      setTimeout(function(){
        $notification.remove();
      }, 1000);
    },
    closeNotificationByID: function(id) {
      var $notification = $('.c-notifications__item[data-notification_id=' + id + ']');
      if ($notification.length) {
        this.closeNotification($notification);
      }
    },
    closeAll: function() {
      var $notifications = $('.c-notifications__item');
      if ($notification.length) {
        this.closeNotification($notifications);
      }
    },
    preset: function(id) {
      // Current presets: close_to_reserve_price
      var content;
      var t = 1800;
      var img = $('.cw-lot-images-thumbs img').eq(0).attr('src') || $('.cw-image-big img').eq(0).attr('src');
      var url = null;
      if (id == 'close_to_reserve_price') {
        var reserve_price = I18n.translate('reserve_price');
        if ($('html').attr('lang') != 'de') {
          reserve_price = reserve_price.toLowerCase();
        }
        content = "<strong>" + I18n.translate('almost_there_2') + "</strong> " + I18n.translate('reserve_price_almost_met', { link: reserve_price });
        window.cwNotifications.setBidGoal('bid_when_rp_almost_met');
      }
      if (content) {
        return window.cwNotifications.notify(content, t, img, url, id);
      }
      return false;
    },
    setBidGoal: function(key) {
      if(window.targetAbGoal){
        window.targetAbGoal.setGoal(key);
      }
    }
  }

  window.cwAlerts = {
    createAlert: function(type, content) {
      var $alert = $('<div/>', {'class': ('hide c-alert ' + type)});
      if(typeof(content) === "object"){
        var $title = $('<h3/>', {'html': content.title, 'class': 'c-alert__heading'});
        $alert.html($title);
        $alert.append(content.message);
      }else{
        $alert.html(content);
      }
      return $alert;
    },
    removeAlert: function($alert, duration) {
      setTimeout(function(){
        $alert.fadeOut(500, function(){
          $(this).remove();
        });
      }, duration);
    },
    setAlert: function(type, content, container, duration, callback) {
      if(!type || !content){
        return;
      }
      var $alert = this.createAlert(type, content);
      var $container = !!container ? $(container) : $('#flash');
      $alert.prependTo($container).fadeIn(500);
      if(!!duration){
        this.removeAlert($alert, duration);
      }
      if(!!callback){
        callback();
      }
    }
  }


  // AB tests on search
  var cwSearchAbTests = function() {

    if(I18n && I18n.translate && typeof(AB) != "undefined" && AB != null){
      // different search placeholder for en and nl
      var $search_input = $('.cw-header #search_lots_query');
      if($search_input.length > 0 && ['en', 'nl'].indexOf($('body').data('lang')) != -1 &&
          I18n.translate('what_are_you_looking_for').indexOf('translation missing:') == -1) {
        $search_input.attr('placeholder', I18n.translate('what_are_you_looking_for'));
      }
    }
  };

  // Helpers
  var cwPluralize = function($el, n) {
    if (n == 1) {
      $el.text($el.data('singular'));
    } else {
      $el.text($el.data('plural'));
    }
  };
  function cw_iOS() {
    return (
      (/iphone|ipod|ipad/gi).test(navigator.appVersion)
    );
  }
  function cw_iPad() {
    return (
      (/ipad/gi).test(navigator.appVersion)
    );
  }
  function cw_android() {
    return (
      (/android/gi).test(navigator.appVersion)
    );
  }
  function supportCanvas() {
    return !!window.CanvasRenderingContext2D;
  }

  var cwGetSelectedOptionText = function($element) {
    if ($element.length > 0) {
      try { return $($element.get(0).options[$element.get(0).selectedIndex]).text(); }
      catch(err) { return $($element.get(0).options[$element.eq(0).selectedIndex]).text(); }
    }
  };

  var cwOpenInApp = function() {
    var $app_btn = $('.cw-open_in_app_button');
    var $app_banner = $('#cw_app_signup_linkbanner');
    if($app_btn.length > 0 &&
        !!window.user_id &&
        (cw_iOS() || cw_android()) &&
        cw_store.get_session('open_in_app_button_hidden') !== 'true' &&
        typeof(AB) !== 'undefined' &&
        AB.test('all_auctions_menu_outer') == 'A') {

      var ab_key = cw_iOS() ? 'open_ios_app_button' : 'open_android_app_button';
      if(AB.test(ab_key) == 'B') {
        $app_btn.removeClass('hidden');
        $app_btn.find('.close').on('click', function(){
          $app_btn.addClass('hidden');
          cw_store.set_session('open_in_app_button_hidden', 'true');
        });
        $app_banner.hide();
      } else {
        var $app_banner_link = $app_banner.find('a:visible');
        var new_app_banner_link_url = $app_banner_link.attr('href') + '&creative={openinappA}';
        $app_banner_link.attr('href', new_app_banner_link_url);
      }
    }
  }

  /**
   * Throttle function borrowed from:
   * Underscore.js 1.5.2
   * http://underscorejs.org
   * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   * Underscore may be freely distributed under the MIT license.
   */
  function throttle(func, wait) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    var later = function() {
      previous = new Date();
      timeout = null;
      result = func.apply(context, args);
    };
    return function() {
      var now = new Date();
      if (!previous) {
        previous = now;
      }
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0) {
        clearTimeout(timeout);
        timeout = null;
        previous = now;
        result = func.apply(context, args);
      } else if (!timeout) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  }

  //AB click conversions
  var abClickConversions = function() {
    $('.cw-ab_click').on('click.ab-click-conversion', function(){
      if($(this).hasClass('active')) return false;
      var goal = $(this).data('ab-conversion');
      var ab_id =  $(this).data('ab-id');
      var ab_label = $(this).text();
      if(ab_id && ab_label){
        //ga('send', 'event', 'AB testing', ab_id, ab_label.trim(), {nonInteraction:false});
        dataLayer.push({
          'event': 'ab_click',
          'eventCategory': 'AB testing',
          'eventAction': ab_id,
          'eventLabel': ab_label.trim(),
        });
      }
    });
  };

  function user_is_logged_in(){
    var user_name = jQuery.cookie('user_name');
    return (user_name && typeof user_name == "string");
  }

  var initToggleThemedAuctions = function() {
    if(!user_is_logged_in()){
      cw_show_lists_auctions_themed();
    }
  };

  var initToggleListsAuctionActual = function() {
    if(!user_is_logged_in()){
      cw_show_lists_auctions_actual();
    }
  };

  $(window).on('load', function() {
    if (!user_is_logged_in() && !$('body').hasClass("cw_mobile")) {
      var path = window.location.pathname;

      if (path.indexOf('/r/') === 0) {
        var url = $('.register_link').attr('data-magnific-popup-link');
        setTimeout(function() { cw_open_register_modal($, url); }, 1000);
      }
    }
  });

  // start it all...
  $(document).ready(function() {
    $('html').removeClass('no-js').addClass('js');
    if (cw_iOS()) {
      $('html').addClass('browser-ios');
      if (cw_iPad()) {
        $('html').addClass('browser-ipad');
      }
    } else {
      $('html').addClass('browser-not_ios');
    }
    if (cw_android()) {
      $('html').addClass('browser-android');
    } else {
      $('html').addClass('browser-not_android');
    }
    // provide fallbacks: IE7 doesn't get isotope and imagesLoaded...
    if(!$().isotope) {
      $.fn.extend({
        isotope: function(){}
      });
    }
    if(!$().imagesLoaded) {
      $.fn.extend({
        imagesLoaded: function(cb){
          setTimeout(function(){
            cb();
          }, 1000);
        }
      });
    }
    if (!disable_cookies_for_user()){
      loadSocialMediaAsync();
    }
    cwToggleLinks();
    cwCollapsibles();
    window.cwInitResponsiveness();
    $('.cw-sticky').makeSticky();
    $('a.cw-new_window').newWindow();
    $('a.cw-popup_link').newWindow('width=750,height=525,status=1,location=1');
    pageFillHeight();
    smoothAnchors(75);
    initLazyload();
    initToggleListsAuctionActual();
    initToggleThemedAuctions();
    $('#cw_auctioneers_overview').imagesLoaded(function(){
      $('#cw_auctioneers_overview .cw-list-item .cw-content .info').sameHeight();
      $('#cw-main .cw-tiles-fixed_height .cw-list-item .cw-content h2').sameHeight();
      var tiles = new Mason('#all .cw-tiles.cw-msnry', '.cw-list-item');
      tiles.init();
      cwAuctioneers();
    });
    window.setTimeout(function(){
      $('#cw_jobs_overview .cw-list-item .cw-content h1').sameHeight();
      $('#cw_jobs_overview .cw-list-item .cw-content .info').sameHeight();
    }, 0);
    $('#all .cw-list-agenda li').sameHeight(); // zit in verborgen tab, dus meteen, anders doet ie t niet...
    $('#cw-main .cw-tiles, #cw-main .cw-horizontal_tiles, #cw-free_valuation_promo').blockLinks();
    cwTabs();
    setLoginClass();
    activatePopups();
    window.inlineHints.init();
    initGalleries();
    showLoginModal();
    mediaQuotes();
    changeSVGtoPNG();
    $('input, textarea').placeholder();
    cwLotGallery();
    cwSlider();
    cwNiceSelects();
    $('.cw-has_tooltip').cwTooltip();
    //$('.cw-stick_to_top').stickToTop();
    cwBacklinks();
    $().UItoTop({ containerID: 'cw_to_top', scrollSpeed: 400, easingType: 'swing' });
    appSignup();
    toggleGrid();
    abClickConversions();
    calculateShippingCosts();
    searchAutocomplete.init();
    window.cwNotifications.init();
    cwSearchAbTests();

    if(I18n && I18n.translate && (I18n.translate('start_selling').indexOf('translation missing:') == -1) && (typeof AB !== "undefined" && AB.test('start_selling_text') == 'B')){
      var sell_text = I18n.translate('start_selling');
      $('.cw-header, .cw-hero').find("a[href*='/auction_lot_wizard/start']").text(sell_text);
    }

    areYouSureLinks();
    dynamiclyLoadedAuctions();
    cwOpenInApp();
  });

})(jQuery);
